module.exports = __webpack_public_path__ + "img/epr-article-top-img@2x.c4460bc1.jpg";